import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import * as MySound from '../../MySound';
import { alert } from 'react-bootstrap-confirmation';

export class AddNew_ProductSearch extends Component {
    static displayName = AddNew_ProductSearch.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            alertMessage: "",
            selectedStocktake: "",
            selectedLocationBarcode: props.location.state.selectedLocationBarcode,
            selectedLocationId: props.location.state.selectedLocationId,
            searchText: "",
            searchType:"Barcode",
            previouspage: props.location.state.previouspage,
            displayProductSearch: true,
            displayProductSelect: false,
            barcodeSearchText: "",
            productSearchText: "",
            desc1SearchText: "",
            desc2SearchText: "",
            productSelectAlertMessage: "",
            products: [],
            selectedProductId:0
        };
        this.history = props.history;
    }

    componentDidMount() {

        if (!MyGlobal.selected_stocktake) {
            this.clearAll("Please select a Stocktake");
            return;
        }

        var selectedStocktakeParsedData = JSON.parse(MyGlobal.selected_stocktake);
        if (selectedStocktakeParsedData) {
            this.state.selectedStocktake = selectedStocktakeParsedData;
        }

        if (!this.state.selectedStocktake.stocktakeId || this.state.selectedStocktake.stocktakeId === "") {
            this.clearAll("Please select a Stocktake");
            return;
        }
    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    clearAll(message) {
        this.setState({
            alertMessage: message,
            loading: false,
            selectedLocationBarcode: "",
            selectedLocationId: ""

        });
    }



    handleSearchEvent(text, type) {

        this.setState({ alertMessage: "" });
        this.state.searchText = text;
        this.state.searchType = type;

        if (!this.state.searchText || this.state.searchText === "") {
            this.setState({ alertMessage: "You can not search for nothing" });
            return;
        }

        this.loadProducts();
    }

    selectProduct(selectedRowItem) {
        this.state.selectedProductId = selectedRowItem.product_Id;
        this.history.push({
            pathname: 'AddNew_ProductCount',
            state: this.state
        });
    }

    async loadProducts() {
        this.state.loading = true;

        fetch(`api/Stocktake/SearchProducts?stocktakeId=${this.state.selectedStocktake.stocktakeId}&searchText=${this.state.searchText}&searchType=${this.state.searchType}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ products: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;


                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data && data.length > 0) {
                                this.setState({ products: data, alertMessage: "", displayProductSearch: false, displayProductSelect: true });
                            }
                            else {
                                MySound.play(MySound.Sound.stop);
                                this.setState({ products: [], alertMessage: "No Products Found" });
                            }
                        }
                        else {
                            this.setState({ alertMessage: apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "No Products Found" });
                    }
                }

            })
            .catch(error => {
                this.setState({ products: [], alertMessage: error });
            });
    }

    render() {

        let loadingHtml = this.state.loading
            ? <p><em>Searching products...</em></p>
            : "";


        let productsHtml = this.state.loading
            ? <p><em>Searching products...</em></p>
            : this.renderProducts();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let productSelectAlertMessage = this.state.productSelectAlertMessage;
        productSelectAlertMessage = productSelectAlertMessage != "" ? <MyAlert variant="danger">{productSelectAlertMessage}</MyAlert> : "";

        return (
            <div>
                
                <Container fluid classsname="productSearchContainer" style={{ display: this.state.displayProductSearch ? 'block' : 'none' }} >
                    {loadingHtml}
                    <Row className="mb-3">
                        <Col xs={9}><h5>Add Extra - Find Product</h5></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('AddNew_ProductLocation'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>{alertMessage}</Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={12}>
                            <label>Selected Location</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <label> {this.state.selectedLocationBarcode} </label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <label>Barcode</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={9}>
                            <input ref="barcodeInput" className="form-control" value={this.state.barcodeSearchText} onKeyPress={(e) => { if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) { this.handleSearchEvent(this.state.barcodeSearchText, "Barcode") }}}
                                onChange={(e) => {
                                    this.setState({ barcodeSearchText: e.target.value, searchType:"Barcode" });
                                }} >
                            </input>
                        </Col>
                        <Col xs={3}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.handleSearchEvent(this.state.barcodeSearchText, "Barcode") }}>Search</button>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={12}>
                            <label>Product</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={9}>
                            <input ref="productInput" className="form-control" value={this.state.productSearchText} onKeyPress={(e) => { if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) { this.handleSearchEvent(this.state.productSearchText, "Product") } }}
                                onChange={(e) => {
                                    this.setState({ productSearchText: e.target.value, searchType: "Product" });
                                }} >
                            </input>
                        </Col>
                        <Col xs={3}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.handleSearchEvent(this.state.productSearchText, "Product") }}>Search</button>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={12}>
                            <label>Description 1</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={9}>
                            <input ref="desc1Input" className="form-control" value={this.state.desc1SearchText} onKeyPress={(e) => { if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) { this.handleSearchEvent(this.state.desc1SearchText, "Desc1") } }}
                                onChange={(e) => {
                                    this.setState({ desc1SearchText: e.target.value, searchType: "Desc1" });
                                }} >
                            </input>
                        </Col>
                        <Col xs={3}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.handleSearchEvent(this.state.desc1SearchText, "Desc1") }}>Search</button>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={12}>
                            <label>Description 2</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={9}>
                            <input ref="desc2Input" className="form-control" value={this.state.desc2SearchText} onKeyPress={(e) => { if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) { this.handleSearchEvent(this.state.desc2SearchText, "Desc2") } }}
                                onChange={(e) => {
                                    this.setState({ desc2SearchText: e.target.value, searchType: "Desc2" });
                                }} >
                            </input>
                        </Col>
                        <Col xs={3}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.handleSearchEvent(this.state.desc2SearchText, "Desc2") }}>Search</button>
                        </Col>
                    </Row>
                </Container>

                <Container fluid classsname="productSelectContainer" style={{ display: this.state.displayProductSelect ? 'block' : 'none' }}>
                    <Row className="mb-3">
                        <Col xs={3}><h5>Select Product</h5></Col>
                        <Col xs={6}></Col>
                        <Col xs={3}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.setState({ displayProductSearch: true, displayProductSelect:false }) }} >Back</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>{productSelectAlertMessage}</Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={12}>
                            <label>Selected Location</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <label> {this.state.selectedLocationBarcode} </label>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {productsHtml}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }


    renderProducts() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Product</label>
                                <br />
                            </th>
                            <th className="col-sm-4">
                                <label>Desc1</label>
                                <br />
                            </th>
                            <th className="col-sm-4">
                                <label>Desc2</label>
                                <br />
                            </th>
                            <th className="col-sm-4">
                                <label>Barcode</label>
                                <br />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.products
                            .map(row =>
                                <tr key={row.product_Id} onClick={() => { this.selectProduct(row) }}>
                                    <td>{row.code}</td>
                                    <td>{row.description}</td>
                                    <td>{row.species}</td>
                                    <td>{row.bar_Code}</td>

                                  
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }


}
